import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  imagePath: string = 'error.404.default.avatar';
  imageAlt: string = 'error.404.default.avatar.alt';
  title: string = 'error.404.default.title';
  message: string = 'error.404.default.message';
}
